import React, { useEffect, useState } from 'react';
import { fetchProducts } from '../api';
import TableView from './TableView';
import ProductForm from './ProductForm';

const Cells = () => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    const loadProducts = async () => {
      try {
        const data = await fetchProducts();
        setProducts(data);
      } catch (error) {
        console.error('Failed to fetch products:', error);
      }
    };
    loadProducts();
  }, []);

  return (
    <div className="p-3">
      <h2>Комірки</h2>
      <ProductForm setProducts={setProducts} />
      <TableView products={products} />
    </div>
  );
};

export default Cells;
